const Header = () => {
    return (
        <div className="w-full mx-auto px-12 pt-8 pb-14 text-zinc-800 dark:text-zinc-200 text-sm">
            <div className="flex flex-cols items-end">
                <div className="flex-none w-9/12">
                    <div className="flex flex-row items-center space-x-2">
                        <span className="bg-purple-500 inline-block h-2 w-2 rounded-full shadow-[0_0_8px_#a855f7]"></span>
                        <span className="block mt-4 lg:inline-block lg:mt-0 text-purple-600 dark:text-purple-400 mr-4 uppercase font-sans text-xs tracking-widest font-semibold">Legal</span>
                    </div>
                    <h1 className="py-4 text-5xl font-bold text-zinc-900 dark:text-white">
                        Our <span className="text-purple-600 dark:text-purple-400">Privacy Policy</span>
                    </h1>
                    <p className="text-sm text-zinc-500 dark:text-zinc-400">We are committed to protecting your privacy and safeguarding your personal information.</p>
                </div>
            </div>
        </div>
    )
}

export default Header